import { employeeRecords as reducer } from "./reducer";
import { loadEmployeeRecords, loadEmployeeRecordsSuccess } from "./actions";
import * as selectors from "./selectors";
import { EmployeeRecord } from "./model";

export {
    reducer,
    loadEmployeeRecords,
    loadEmployeeRecordsSuccess,
    selectors,
    EmployeeRecord
};
